import {z} from 'zod';

import i18n from '@dms/i18n';

export const EmployeeProfessionsFormSchema = z.object({
  description: z
    .string({required_error: i18n.t('general.validations.fieldIsRequired')})
    .trim()
    .min(1, i18n.t('general.validations.fieldIsRequired')),
  type: z.string().nullish(),
});

export type EmployeeProfessionsForm = z.infer<typeof EmployeeProfessionsFormSchema>;
